import gypsumProject1 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.40 (1).webp';
import gypsumProject2 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.40.webp';
import gypsumProject3 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.41.webp';
import gypsumProject4 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.45.webp';
import gypsumProject5 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.46.webp';
import gypsumVideo1 from '../../assets/GypsumCeilngProjects/WhatsApp Video 2026-04-29 at 22.06.05.mp4';
import gypsumVideo2 from '../../assets/GypsumCeilngProjects/WhatsApp Video 2026-04-29 at 22.06.20.mp4';
import kitchenVideo1 from '../../assets/Kitchen/WhatsApp Video 2026-04-29 at 22.00.30.mp4';
import kitchenVideo2 from '../../assets/Kitchen/WhatsApp Video 2026-04-29 at 22.03.02.mp4';
import tvProject1 from '../../assets/Tv/Tv1.webp';
import tvProject2 from '../../assets/Tv/Tv2.webp';
import tvProject3 from '../../assets/Tv/Tv3.webp';
import featureGypsum1 from '../../assets/Gypsum Wall Unit/IMG-20260417-WA0021.webp';
import featureGypsum2 from '../../assets/Gypsum Wall Unit/IMG-20260417-WA0022.webp';

import prevProject1 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.09.53.jpeg';
import prevProject2 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.09.55.jpeg';
import prevProject3 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.09.56.jpeg';
import prevProject4 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.33 (1).jpeg';
import prevProject5 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.33 (2).jpeg';
import prevProject6 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.33.jpeg';
import prevProject7 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.34 (1).jpeg';
import prevProject8 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.34 (2).jpeg';
import prevProject9 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.34.jpeg';
import prevProject10 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.35 (1).jpeg';
import prevProject11 from '../../assets/Previous projects/WhatsApp Image 2026-05-10 at 18.10.35.jpeg';
import prevVideo1 from '../../assets/Previous projects/WhatsApp Video 2026-05-10 at 18.10.32.mp4';
import prevVideo2 from '../../assets/Previous projects/WhatsApp Video 2026-05-10 at 18.10.34.mp4';
import prevVideo3 from '../../assets/Previous projects/WhatsApp Video 2026-05-10 at 18.10.35.mp4';

import tvPuStone1 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.28 (1).jpeg';
import tvPuStone2 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.28.jpeg';
import tvPuStone3 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.29.jpeg';

import tvCrystal1 from '../../assets/TV wall unit with crystal charcoal board decoration/WhatsApp Image 2026-05-10 at 18.26.22 (1).jpeg';
import tvCrystal2 from '../../assets/TV wall unit with crystal charcoal board decoration/WhatsApp Image 2026-05-10 at 18.26.22.jpeg';

import wainscot1 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11 (1).jpeg";
import wainscot2 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11 (2).jpeg";
import wainscot3 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11.jpeg";
import wainscot4 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.12.jpeg";

const FOLDER_PREVIOUS = 'Previous projects';
const FOLDER_TV_PU_STONE = 'TV wall unit with Pu stone decoration';
const FOLDER_TV_CRYSTAL = 'TV wall unit with crystal charcoal board decoration';
const FOLDER_WAINSCOT = "Wainscoting panels design's";

const formatFolderLabel = (folder) => {
  if (folder === 'GypsumCeilngProjects') {
    return 'Gypsum Ceiling';
  }
  if (folder === FOLDER_PREVIOUS) {
    return 'Previous Projects';
  }
  if (folder === FOLDER_TV_PU_STONE) {
    return 'TV Wall — PU Stone';
  }
  if (folder === FOLDER_TV_CRYSTAL) {
    return 'TV Wall — Crystal Charcoal';
  }
  if (folder === FOLDER_WAINSCOT) {
    return 'Wainscoting';
  }

  return folder
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[-_]/g, ' ')
    .trim();
};

export const allProjects = [
  
  {
    id: 'project-1',
    title: 'Commercial Lobby Ceiling Upgrade',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'image',
    media: gypsumProject2,
    details: 'Elegant lobby ceiling finish for high-traffic use.'
  },{
    id: 'project-2',
    title: 'Modern Apartment Gypsum Ceiling',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'image',
    media: gypsumProject1,
    details: 'Clean layered ceiling with integrated lighting.',
    featured: true
  },
  {
    id: 'project-3',
    title: 'Office Boardroom Feature Ceiling',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'image',
    media: gypsumProject3,
    details: 'Acoustic-friendly gypsum styling with soft profiles.'
  },
  {
    id: 'project-4',
    title: 'TV Wall Units with Fluted Panels & Marble Sheets',
    folder: 'Tv',
    folderLabel: formatFolderLabel('TV Wall Units'),
    type: 'image',
    media: tvProject1,
    details: 'Modern entertainment unit with textured cladding.'
  },
  {
    id: 'project-5',
    title: 'Executive Office Media Wall',
    folder: 'Tv',
    folderLabel: formatFolderLabel('TV Wall Units'),
    type: 'image',
    media: tvProject2,
    details: 'Storage and display integration with ambient lighting.'
  },
  {
    id: 'project-6',
    title: 'Luxury Residence Wall Unit',
    folder: 'Tv',
    folderLabel: formatFolderLabel('TV Wall Units'),
    type: 'image',
    media: tvProject3,
    details: 'Premium wall finish and TV mounting solution.'
  },
  {
    id: 'project-7',
    title: 'Gypsum Feature Wall Installation',
    folder: 'Gypsum Wall Unit',
    folderLabel: formatFolderLabel('Gypsum Wall Unit'),
    type: 'image',
    media: featureGypsum1,
    details: 'Statement wall with seamless gypsum finish.'
  },
  {
    id: 'project-8',
    title: 'Gypsum Storage Wall Build',
    folder: 'Gypsum Wall Unit',
    folderLabel: formatFolderLabel('Gypsum Wall Unit'),
    type: 'image',
    media: featureGypsum2,
    details: 'Built-in niches and hidden storage in one unit.'
  },
  {
    id: 'project-9',
    title: 'Ceiling Transformation Walkthrough',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'video',
    media: gypsumVideo1,
    thumbnail: gypsumProject1,
    details: 'Video preview of before/after gypsum execution.'
  },
  {
    id: 'project-10',
    title: 'Custom Ceiling Installation Reel',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'video',
    media: gypsumVideo2,
    thumbnail: gypsumProject2,
    details: 'Installation highlights from a completed project.'
  },
  {
    id: 'project-11',
    title: 'Drop Ceiling Detailing',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'image',
    media: gypsumProject4,
    details: 'Detailed profile lines and lighting recesses.'
  },
  {
    id: 'project-12',
    title: 'Open Space Ceiling Design',
    folder: 'GypsumCeilngProjects',
    folderLabel: formatFolderLabel('GypsumCeilngProjects'),
    type: 'image',
    media: gypsumProject5,
    details: 'Wide-area gypsum design for collaborative spaces.'
  },
  {
    id: 'project-13',
    title: 'Kitchen Installation Walkthrough',
    folder: 'Kitchen',
    folderLabel: formatFolderLabel('Kitchen'),
    type: 'video',
    media: kitchenVideo1,
    thumbnail: prevProject1,
    details: 'Step-by-step kitchen fit-out project progress.'
  },
  {
    id: 'project-14',
    title: 'Kitchen Finishing Showcase',
    folder: 'Kitchen',
    folderLabel: formatFolderLabel('Kitchen'),
    type: 'video',
    media: kitchenVideo2,
    thumbnail: prevProject2,
    details: 'Final kitchen finishing and detailing highlights.'
  },
  {
    id: 'project-15',
    title: 'Interior Fit-Out — Living Zone',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject1,
    details: 'Completed residential finishing and ambience.'
  },
  {
    id: 'project-16',
    title: 'Interior Fit-Out — Detail View',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject2,
    details: 'Trim, lighting, and cohesive material palette.'
  },
  {
    id: 'project-17',
    title: 'Interior Fit-Out — Feature Area',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject3,
    details: 'Balanced proportions and refined wall treatments.'
  },
  {
    id: 'project-18',
    title: 'Residential Interior ',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject4,
    details: 'Full-scope interior workmanship from recent work.'
  },
  {
    id: 'project-19',
    title: 'Residential Interior ',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject5,
    details: 'Layered textures and curated finishes.'
  },
  {
    id: 'project-20',
    title: 'Residential Interior — Wide View',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject6,
    details: 'Open-plan flow with cohesive ceiling and wall detail.'
  },
  {
    id: 'project-21',
    title: 'Completed Space — Alternate Angle',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject7,
    details: 'Lighting integration and spatial clarity.'
  },
  {
    id: 'project-22',
    title: 'Completed Space — Finishing Highlights',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject8,
    details: 'Precision edging and cabinetry alignment.'
  },
  {
    id: 'project-23',
    title: 'Home Interior — Ambient Mood',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject9,
    details: 'Warm tones and understated feature elements.'
  },
  {
    id: 'project-24',
    title: 'Home Interior — Walkthrough Angle',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject10,
    details: 'Clear sightlines across living and circulation.'
  },
  {
    id: 'project-25',
    title: 'Home Interior — Final Handover Look',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'image',
    media: prevProject11,
    details: 'Move-in-ready detailing and cleanliness.'
  },
  {
    id: 'project-26',
    title: 'Interior Progress ',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'video',
    media: prevVideo1,
    thumbnail: prevProject1,
    details: 'Quick look at workmanship in place.'
  },
  {
    id: 'project-27',
    title: 'Interior Progress',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'video',
    media: prevVideo2,
    thumbnail: prevProject2,
    details: 'On-site interior execution highlights.'
  },
  {
    id: 'project-28',
    title: 'Interior Progress ',
    folder: FOLDER_PREVIOUS,
    folderLabel: formatFolderLabel(FOLDER_PREVIOUS),
    type: 'video',
    media: prevVideo3,
    thumbnail: prevProject3,
    details: 'Finishing stage walkthrough excerpt.'
  },
  {
    id: 'project-29',
    title: 'TV Wall with PU Stone Cladding — Main View',
    folder: FOLDER_TV_PU_STONE,
    folderLabel: formatFolderLabel(FOLDER_TV_PU_STONE),
    type: 'image',
    media: tvPuStone1,
    details: 'Feature wall texture with recessed TV niche.'
  },
  {
    id: 'project-30',
    title: 'TV Wall with PU Stone Cladding — Storage Side',
    folder: FOLDER_TV_PU_STONE,
    folderLabel: formatFolderLabel(FOLDER_TV_PU_STONE),
    type: 'image',
    media: tvPuStone2,
    details: 'Balanced cabinetry and stone panelling continuity.'
  },
  {
    id: 'project-31',
    title: 'TV Wall with PU Stone — Full Composition',
    folder: FOLDER_TV_PU_STONE,
    folderLabel: formatFolderLabel(FOLDER_TV_PU_STONE),
    type: 'image',
    media: tvPuStone3,
    details: 'Single plane media wall with soft lighting accents.'
  },
  {
    id: 'project-32',
    title: 'Crystal Charcoal Board TV Feature Wall',
    folder: FOLDER_TV_CRYSTAL,
    folderLabel: formatFolderLabel(FOLDER_TV_CRYSTAL),
    type: 'image',
    media: tvCrystal1,
    details: 'Charcoal board panels framing the display zone.'
  },
  {
    id: 'project-33',
    title: 'Crystal Charcoal Board Wall — Alternate View',
    folder: FOLDER_TV_CRYSTAL,
    folderLabel: formatFolderLabel(FOLDER_TV_CRYSTAL),
    type: 'image',
    media: tvCrystal2,
    details: 'Linear grain and restrained hardware lines.'
  },
  {
    id: 'project-34',
    title: 'Wainscoting Panels — Elevated Formal Look',
    folder: FOLDER_WAINSCOT,
    folderLabel: formatFolderLabel(FOLDER_WAINSCOT),
    type: 'image',
    media: wainscot1,
    details: 'Classic panel proportions with crown transition.'
  },
  {
    id: 'project-35',
    title: 'Wainscoting Panels — Corner & Joinery',
    folder: FOLDER_WAINSCOT,
    folderLabel: formatFolderLabel(FOLDER_WAINSCOT),
    type: 'image',
    media: wainscot2,
    details: 'Crisp intersections and repeatable rail rhythm.'
  },
  {
    id: 'project-36',
    title: 'Wainscoting Panels — Straight Run',
    folder: FOLDER_WAINSCOT,
    folderLabel: formatFolderLabel(FOLDER_WAINSCOT),
    type: 'image',
    media: wainscot3,
    details: 'Uniform chair-rail height and shadow detail.'
  },
  {
    id: 'project-37',
    title: 'Wainscoting Panels — Room Perspective',
    folder: FOLDER_WAINSCOT,
    folderLabel: formatFolderLabel(FOLDER_WAINSCOT),
    type: 'image',
    media: wainscot4,
    details: 'Panelled lower wall with breathable upper contrast.'
  }
];

export const projectFilters = ['All', ...Array.from(new Set(allProjects.map((project) => project.folderLabel)))];
